import React, { useEffect, useState } from 'react';
import lightlogo from '@assets/images/logos/lightlogo.svg';
import darklogo from '@assets/images/logos/darklogo.svg';

export function Logo({ className = '', ...props }) {
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  useEffect(() => {
    // Check initial theme
    const checkDarkMode = () => {
      setIsDarkMode(document.documentElement.classList.contains('dark'));
    };
    
    // Set initial value
    checkDarkMode();
    
    // Set up observer to detect theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          checkDarkMode();
        }
      });
    });
    
    observer.observe(document.documentElement, { attributes: true });
    
    return () => observer.disconnect();
  }, []);
  
  // In dark mode, use the light logo for better contrast
  // In light mode, use the dark logo for better contrast
  return (
    <img 
      src={isDarkMode ? darklogo : lightlogo} 
      alt="LineLeaders" 
      className={className} 
      {...props} 
    />
  );
}

export default Logo; 